var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.70998C22.5495 4.27864 22.2365 2.858 21.59 1.57998C21.1514 1.05558 20.5427 0.701694 19.87 0.579984C17.0875 0.327509 14.2936 0.224028 11.5 0.269984C8.71667 0.221942 5.93274 0.322084 3.16003 0.569984C2.61185 0.669701 2.10454 0.926826 1.70003 1.30998C0.800027 2.13998 0.700027 3.55998 0.600027 4.75998C0.454939 6.91755 0.454939 9.08242 0.600027 11.24C0.628957 11.9154 0.729521 12.5858 0.900027 13.24C1.0206 13.745 1.26455 14.2123 1.61003 14.6C2.01729 15.0034 2.53641 15.2752 3.10003 15.38C5.25594 15.6461 7.42824 15.7564 9.60003 15.71C13.1 15.76 16.17 15.71 19.8 15.43C20.3775 15.3316 20.9112 15.0595 21.33 14.65C21.61 14.3699 21.8191 14.0271 21.94 13.65C22.2977 12.5526 22.4733 11.4041 22.46 10.25C22.5 9.68998 22.5 6.30998 22.5 5.70998ZM9.24003 10.85V4.65998L15.16 7.76998C13.5 8.68998 11.31 9.72998 9.24003 10.85Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ba2b68509e41011edd94d206d173aa9c.svg";
export { ForwardRef as ReactComponent };